import styled from 'styled-components';
import {device} from '../../../../../utils/utils';

export const SlctMnthCnt = styled.div`
  position: relative;
  @media ${device.mobileS} {
  }
`;
export const SlctMnth = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  padding: 9px 18px;
  display: flex;
  align-items: center;
  min-width: 145px;
  &::after {
    content: '';
    display: inline-flex;
    border: solid #008cff;
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(45deg);
    margin-left: auto;
  }
  @media ${device.mobileS} {
  }
`;
export const SlctMnthVal = styled.p`
  font-size: 14px;
  color: #000000;
  font-weight: 600;
  @media ${device.mobileS} {
  }
`;
export const SlctMnthList = styled.ul`
  width: 100%;
  //height: 150px;
  background-color: #fff;
  position: absolute;
  right: 0;
  top: 40px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow-y: auto;
  z-index: 2;
  @media ${device.mobileS} {
  }
`;
export const SlctMnthListItm = styled.li`
  font-size: 14px;
  cursor: pointer;
  padding: 5px 10px;
  @media ${device.mobileS} {
  }
`;
